import { css } from "@linaria/core";
import { styled } from "@linaria/react";
import { Checkbox } from "reakit/Checkbox";
import { BaseHTMLAttributes, forwardRef, ReactElement } from "react";
import { boxCheck, boxRadio, colors, transitionTimingFunction } from "@/styles/utils/vars";
import type { CheckboxPropsType } from "./CustomCheckbox";
import { StyledLinkBase } from "../Link/StyledLink";
import { ErrorMessageField, getTypographyBase, TypographyBase } from "../Typography/Typography";
const offset = 3;
export const CheckboxBox = /*#__PURE__*/styled('span')({
  name: "CheckboxBox",
  class: "CheckboxBox_cbjy19t"
});
export const CheckboxBase = /*#__PURE__*/styled('label')({
  name: "CheckboxBase",
  class: "CheckboxBase_c1e497qp"
});
const CheckboxCheck = /*#__PURE__*/styled(CheckboxBase)({
  name: "CheckboxCheck",
  class: "CheckboxCheck_c1d340gp"
});
const CheckboxRadio = /*#__PURE__*/styled(CheckboxBase)({
  name: "CheckboxRadio",
  class: "CheckboxRadio_c98olzx"
});
export const cssCheckBoxOverlay = "cssCheckBoxOverlay_c1cpiima";
interface CheckboxWrapperType extends BaseHTMLAttributes<HTMLInputElement> {
  ComponentCheckbox: typeof CheckboxCheck | typeof CheckboxRadio;
  message: string | ReactElement;
  errorMessage?: string;
}
const CheckboxWrapper = forwardRef<HTMLInputElement, CheckboxWrapperType>(({
  ComponentCheckbox,
  message,
  className,
  errorMessage,
  ...props
}, ref) => {
  return <>
        <ComponentCheckbox className={className} data-is-error={!!errorMessage}>
          <Checkbox {...props} ref={ref} />
          <CheckboxBox />
          {message}
        </ComponentCheckbox>
        {errorMessage && <ErrorMessageField>{errorMessage}</ErrorMessageField>}
      </>;
});
CheckboxWrapper.displayName = "CheckboxWrapper";
const StyledCheckbox = forwardRef<HTMLInputElement, CheckboxPropsType>(({
  variant = "check",
  ...props
}, ref) => {
  switch (variant) {
    case "check":
      {
        return <CheckboxWrapper ComponentCheckbox={CheckboxCheck} {...props} ref={ref} />;
      }
    case "radio":
      {
        return <CheckboxWrapper ComponentCheckbox={CheckboxRadio} {...props} ref={ref} />;
      }
    default:
      return <></>;
  }
});
StyledCheckbox.displayName = "StyledCheckbox";
export default StyledCheckbox;

require("./StyledCheckbox.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./StyledCheckbox.tsx");